import React from "react";
import { Coffee, Trees, Waves, Dog } from "lucide-react";

const FEATURES = [
  {
    icon: Trees,
    title: "Natureza preservada",
    text: "Imerso na Mata Atlântica de Igaratá, cercado por silêncio e ar puro.",
  },
  {
    icon: Waves,
    title: "Beira da represa",
    text: "Vista panorâmica para a represa do Jaguari e acesso privativo à água.",
  },
  {
    icon: Coffee,
    title: "Café da manhã e jantar",
    text: "Refeições caseiras inclusas em todas as acomodações.",
  },
  {
    icon: Dog,
    title: "Pet friendly",
    text: "Seu melhor amigo é bem-vindo (taxa única de higienização R$ 200).",
  },
];

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-20 md:py-28 bg-[#e8e5d9]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10 md:gap-14">
        <div className="md:col-span-5">
          <p className="text-sm uppercase tracking-[0.2em] text-[#b55a30] font-bold mb-3">
            Sobre nós
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#1a3622] leading-tight">
            Um respiro entre o lago e a floresta.
          </h2>
          <p className="mt-5 text-[#4a6b53] leading-relaxed">
            As Cabanas Igaratá oferecem hospedagem boutique em meio à natureza,
            a poucas horas de São Paulo. Cada chalé tem jacuzzi privativa,
            churrasqueira tipo parrilla argentina, chopeira exclusiva e vista
            para o lago. Um destino feito para casais que querem desacelerar.
          </p>
        </div>

        <div className="md:col-span-7 grid sm:grid-cols-2 gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl bg-[#f7f5f0] border border-[#d1cfc3] p-6 card-soft"
              data-testid={`feature-${f.title}`}
            >
              <div className="h-11 w-11 rounded-full bg-[#1a3622] text-[#f7f5f0] flex items-center justify-center mb-4">
                <f.icon className="h-5 w-5" />
              </div>
              <h3 className="text-lg font-bold text-[#1a3622]">{f.title}</h3>
              <p className="mt-2 text-sm text-[#4a6b53] leading-relaxed">
                {f.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
